<template>
  <div class="d-block" v-if="modalShow">
    <v-dialog
      v-model="modalShow"
      class="modalBranch"
      ref="modalBranch"
      hide-header
      hide-footer
      centered
      body-class="p-0"
      scroll-strategy="none"
    >
      <div class="my-3">
        <div class="modal-confirm-custom text-center title f-xl">
          {{ $t("branch_select_coupon") }}
        </div>
        <v-row>
          <v-col>
            <InputSelect
              v-model:value="selected"
              :options="branch"
              @change="selectBranch"
              :placeholder="$t('branch_select_coupon')"
              value-field="id"
              text-field="name"
              :isValidate="errorSelectBranch"
            >
              <template v-slot:prepend-item>
                <v-list-item :value="null" disabled>
                  --- {{ $t("branch_select_coupon") }} ---
                </v-list-item>
              </template>
            </InputSelect>
            <div class="text-error" v-if="errorSelectBranch">
              Please Select Branch
            </div>
          </v-col>
          <template v-if="detail.is_customer_fill_invoice == 1">
            <v-col cols="12">
              <InputText
                v-model:value="v$.body.invoice_no.$model"
                :textFloat="$t('invoice_no')"
                :placeholder="$t('placeholder') + $t('invoice_no')"
                type="text"
                name="invoice_no"
                size="lg"
                :isRequired="detail.is_customer_fill_invoice == 1"
                :isValidate="v$.body.invoice_no.$error"
                :v="v$.body.invoice_no"
                class="f-regular"
              />
            </v-col>
            <v-col cols="12">
              <InputText
                v-model:value="v$.body.grand_total.$model"
                :textFloat="$t('total_spend')"
                :placeholder="$t('placeholder') + $t('total_spend')"
                type="number"
                name="grand_total"
                size="lg"
                :isRequired="detail.is_customer_fill_invoice == 1"
                :isValidate="v$.body.grand_total.$error"
                :v="v$.body.grand_total"
                class="f-regular"
              />
            </v-col>
          </template>
        </v-row>
      </div>
      <div class="border-top pt-4 text-center">
        <v-row>
          <v-col>
            <c-btn
              @click="confirm"
              class="w-100 btn-confirm"
              variant="confirm-primary"
              :disabled="isDisable"
            >
              {{ $t("confirm") }}
            </c-btn>
            <c-btn
              block
              @click="modalShow = false"
              variant="outline-primary"
              class="mt-2"
            >
              {{ $t("cancel") }}
            </c-btn>
          </v-col>
        </v-row>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";
export default {
  props: {
    branch: {
      required: true,
      type: Array
    },
    detail: {
      required: false,
      type: Object
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      body: {
        invoice_no: {
          required: requiredIf(() => this.detail.is_customer_fill_invoice == 1)
        },
        grand_total: {
          required: requiredIf(() => this.detail.is_customer_fill_invoice == 1)
        }
      }
    };
  },
  data() {
    return {
      modalShow: false,
      selected: null,
      body: {
        grand_total: 0,
        invoice_no: ""
      },
      isDisable: true,
      errorSelectBranch: false
    };
  },
  methods: {
    show(branch_id) {
      this.modalShow = true;
      this.selected = null;
      this.isDisable = branch_id ? false : true;
      this.selected = branch_id;
      this.errorSelectBranch = false;
    },
    close(val) {
      if (val === 1) {
        this.$emit("success", this.msg);
      } else {
        this.$emit("error", this.msg);
      }
      this.modalShow = false;
    },
    hide() {
      this.modalShow = false;
    },
    selectBranch(evt) {
      if (evt) {
        this.errorSelectBranch = false;
        this.isDisable = false;
      }
    },
    confirm() {
      this.v$.body.$touch();
      if (this.v$.body.$error) return;
      if (!this.selected) return (this.errorSelectBranch = true);
      this.$emit("confirm", this.selected, this.body);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  padding: 15px 0;
}
::v-deep .btn-secondary:hover {
  color: #fff;
  background-color: #000000;
  border-color: #000000;
}
</style>
